'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountForm = exports.AccountFormUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _reduxForm = require('redux-form');

var _Sagas = require('decorators/Sagas');

var _decorator = require('helpers/decorator');

var _validators = require('validators');

var _InputField = require('components/FormFields/InputField');

var _Toggle = require('./Toggle');

var _account = require('../sagas/account.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messages = (0, _reactIntl.defineMessages)({
  firstName: {
    id: 'signup-card.account.first-name-placeholder',
    defaultMessage: 'First name'
  },
  lastName: {
    id: 'signup-card.account.last-name-placeholder',
    defaultMessage: 'Last name'
  }
});

var AccountFormUnwrapped = exports.AccountFormUnwrapped = function (_PureComponent) {
  (0, _inherits3.default)(AccountFormUnwrapped, _PureComponent);

  function AccountFormUnwrapped() {
    (0, _classCallCheck3.default)(this, AccountFormUnwrapped);
    return (0, _possibleConstructorReturn3.default)(this, (AccountFormUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(AccountFormUnwrapped)).apply(this, arguments));
  }

  (0, _createClass3.default)(AccountFormUnwrapped, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onMount(this.props.hiddenFields);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          formId = _props.formId,
          handleSubmit = _props.handleSubmit,
          intl = _props.intl,
          searchableDisclaimer = _props.searchableDisclaimer;


      return _react2.default.createElement(
        'form',
        {
          className: 'form',
          id: formId,
          method: 'post',
          noValidate: true,
          onSubmit: handleSubmit
        },
        _react2.default.createElement(_reduxForm.Field, {
          component: _InputField.InputField,
          name: 'firstName',
          inputAttributes: { placeholder: intl.formatMessage(messages.firstName) }
        }),
        _react2.default.createElement(_reduxForm.Field, {
          component: _InputField.InputField,
          name: 'lastName',
          inputAttributes: { placeholder: intl.formatMessage(messages.lastName) }
        }),
        searchableDisclaimer && _react2.default.createElement(
          'div',
          { className: 'text--xs text--left' },
          _react2.default.createElement(_reduxForm.Field, {
            component: _Toggle.Toggle,
            label: searchableDisclaimer,
            name: 'searchable'
          })
        )
      );
    }
  }]);
  return AccountFormUnwrapped;
}(_react.PureComponent);

AccountFormUnwrapped.propTypes = {
  formId: _propTypes2.default.string,
  handleSubmit: _propTypes2.default.func.isRequired,
  hiddenFields: _propTypes2.default.object,
  intl: _reactIntl.intlShape,
  onMount: _propTypes2.default.func.isRequired,
  searchableDisclaimer: _propTypes2.default.string
};

var formConfig = {
  enableReinitialize: true,
  form: _account.ACCOUNT_FORM,
  keepDirtyOnReinitialize: true,
  onSubmit: _account.accountFormAction,
  onSubmitSuccess: function onSubmitSuccess(result, dispatch, props) {
    return props.onSuccess(result);
  },
  validate: (0, _validators.validateFields)(_validators.requiredValidator, ['firstName', 'lastName'])
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    searchableDisclaimer: ((0, _reduxForm.getFormValues)(_account.ACCOUNT_FORM)(state) || {}).searchableDisclaimer
  };
};

var AccountForm = exports.AccountForm = (0, _decorator.decorateWith)((0, _Sagas.withSagas)({ watch: _account.watchAccountFormSagas }), (0, _reactRedux.connect)(mapStateToProps, { onMount: _account.initializeAccountForm }), _reactIntl.injectIntl, (0, _reduxForm.reduxForm)(formConfig), (0, _decorator.withName)('AccountForm'))(AccountFormUnwrapped);